import React, { ReactElement } from 'react';

interface IProps {
  children: any;
  style?: any;
  className?: any;
  width?: string | number;
  bgColor?: string;
}

// Used to chunk content on a page allowing for differing widths on the page
// So if you wanted something wider than the default 960, you'd put it in
// a Block and just change the width. Also allows for easier background changes.
export default function Block({
  children,
  style,
  className = '',
  width = 960,
  bgColor,
}: IProps): ReactElement {
  return (
    <div
      className={`blocker flex justify-center pl-6 pr-6 ${className}`}
      style={{ backgroundColor: bgColor, ...style }}>
      <div style={{ maxWidth: width, width: width }}>{children}</div>
    </div>
  );
}
